"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyProof = void 0;

var lisk_utils_1 = require("@liskhq/lisk-utils");

var constants_1 = require("./constants");

var utils_1 = require("./utils");

var verifyProof = function verifyProof(options) {
  var _options$proof = options.proof,
      path = _options$proof.path,
      indexes = _options$proof.indexes,
      dataLength = _options$proof.dataLength;
  var treeHeight = Math.ceil(Math.log2(dataLength)) + 1;
  var results = new lisk_utils_1.dataStructures.BufferMap();

  if (dataLength === 0 || options.queryData.length === 0) {
    return [{
      hash: options.rootHash,
      verified: true
    }];
  }

  var locationToPathMap = {};

  var _iterator = _createForOfIteratorHelper(path),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;

      if (p.layerIndex !== undefined && p.nodeIndex !== undefined) {
        locationToPathMap["".concat(utils_1.getBinaryString(p.nodeIndex, treeHeight - p.layerIndex))] = p.hash;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _loop = function _loop(i) {
    var queryHash = options.queryData[i];
    var _indexes$i = indexes[i],
        nodeIndex = _indexes$i.nodeIndex,
        layerIndex = _indexes$i.layerIndex;

    if (nodeIndex === undefined || layerIndex === undefined) {
      results.set(queryHash, false);
      return "continue";
    }

    if (dataLength === 1) {
      if (path.some(function (p) {
        return p.hash.equals(queryHash);
      })) {
        results.set(queryHash, true);
      } else {
        results.set(queryHash, false);
      }

      return "continue";
    }

    var currentHash = queryHash;

    while (layerIndex !== treeHeight) {
      var _utils_1$getPairLocat = utils_1.getPairLocation({
        layerIndex: layerIndex,
        nodeIndex: nodeIndex,
        dataLength: dataLength
      }),
          pairLayerIndex = _utils_1$getPairLocat.layerIndex,
          pairNodeIndex = _utils_1$getPairLocat.nodeIndex,
          pairSide = _utils_1$getPairLocat.side;

      var nextPath = locationToPathMap["".concat(utils_1.getBinaryString(pairNodeIndex, treeHeight - pairLayerIndex))];

      if (nextPath === undefined) {
        break;
      }

      var leftHashBuffer = pairSide === 0 ? nextPath : currentHash;
      var rightHashBuffer = pairSide === 1 ? nextPath : currentHash;
      currentHash = utils_1.generateHash(constants_1.BRANCH_PREFIX, leftHashBuffer, rightHashBuffer);
      layerIndex = pairLayerIndex > layerIndex ? pairLayerIndex + 1 : layerIndex + 1;
      nodeIndex = dataLength === Math.pow(2, treeHeight - 1) ? Math.floor(pairNodeIndex / 2) : Math.floor(pairNodeIndex / Math.pow(2, layerIndex - pairLayerIndex));
    }

    if (!currentHash.equals(options.rootHash)) {
      results.set(queryHash, false);
      return "continue";
    }

    results.set(queryHash, true);
  };

  for (var i = 0; i < options.queryData.length; i += 1) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  }

  return results.entries().map(function (result) {
    return {
      hash: result[0],
      verified: result[1]
    };
  });
};

exports.verifyProof = verifyProof;